import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Eventos() {
  const [selectedCategory, setSelectedCategory] = useState('todos');
  const [currentImageIndex, setCurrentImageIndex] = useState<Record<number, number>>({});

  const events = [
    {
      id: 1,
      title: 'Feira Geração Verde Juventude e Acção Climática',
      date: '18 e 19 Nov 2025',
      location: 'Instituto Sapiens',
      category: 'workshop',
      featured: false,
      images: [
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/9b4c219d8c3074a0a7a17959649e8725.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/24b34955f75bffb3789bc469ce49466d.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/eddbb2eb1751542f4e72677da906bd3d.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/fa612d4133b4a51724adb67ebecabfea.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/a584d2319b8e75154f6e2c4d9f337215.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/896c0d3d9695199d1b86a403c5343dcc.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/e9251af58d83888d4c2d6dd9d72b9a64.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/dfbf5c7ab5119f5a9cf8afc8db973b4d.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/567d27b3ca898a88c0189c0246a04d95.jpeg',
      ],
      description: `Iniciativa dedicada à promoção da inovação climática e ao fortalecimento das competências de jovens empreendedores, com foco em soluções sustentáveis, empreendedorismo verde e acção climática.

O evento fomentou a participação activa da juventude na construção de soluções para os desafios ambientais e sociais do país.`,
      status: 'past',
    },
    {
      id: 2,
      title: 'Lançamento do Projecto Crescer',
      date: '13 Out 2025',
      location: 'A anunciar',
      category: 'conferencia',
      featured: false,
      images: [
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/8ecd4b622298c69d4060769a903f9421.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/ba667b0ed49b6e784cf4138a3c058051.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/ab3e18b0d36f3cec6fe6b4b89e096201.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/e208f8c48b79d364fab14f7f7bd5d822.webp',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/e5b4769f93c9c988fe2e1e9628cf732e.jpeg',
      ],
      description: `O Evento de Lançamento do Projecto Crescer marcou o início de uma iniciativa estratégica dedicada à promoção do empreendedorismo, capacitação empresarial e desenvolvimento sustentável, com especial enfoque nas micro, pequenas e médias empresas. A iniciativa teve como objectivo apresentar o enquadramento do projecto, os seus eixos estratégicos e as oportunidades de participação, promovendo o diálogo entre instituições, parceiros estratégicos e beneficiários directos.`,
      status: 'upcoming',
    },
    {
      id: 3,
      title: 'A Semana da Sustentabilidade by INAPEM',
      date: '07 a 10 Abril 2025',
      location: 'A anunciar',
      category: 'conferencia',
      featured: true,
      images: [
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/49bf3c2733b13ac72b3f4f560a5c14a1.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/bfdfd6a284c620c27c056cc6616167e8.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/28bc2143bc4828e28e531946cb6d9931.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/0869f4b2a2dc2ca975684dd3d9c961fd.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/7e94a8618011449037010a605af3ab6e.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/5b92ae6ed9711344cbfa23b50dea5e36.jpeg',
        'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/f6f57ea7342dcf543d31d8ad8b9fa577.jpeg',
      ],
      description: `A Semana da Sustentabilidade by INAPEM, é uma iniciativa estratégica dedicada à promoção de práticas sustentáveis no tecido empresarial angolano, com foco nas micro, pequenas e médias empresas.


O evento reforça o compromisso com a capacitação empresarial, a inovação sustentável e a construção de modelos de negócio mais resilientes, competitivos e alinhados às boas práticas internacionais.`,
      status: 'upcoming',
    },
  ];

  const categories = [
    { id: 'todos', label: 'Todos' },
    { id: 'conferencia', label: 'Conferências' },
    { id: 'workshop', label: 'Workshops' },
    { id: 'webinar', label: 'Webinars' },
    { id: 'treinamento', label: 'Formação' },
    { id: 'networking', label: 'Networking' },
  ];

  const filteredEvents = selectedCategory === 'todos' 
    ? events 
    : events.filter(event => event.category === selectedCategory);

  const handlePrevImage = (eventId: number, totalImages: number) => {
    setCurrentImageIndex(prev => ({
      ...prev,
      [eventId]: ((prev[eventId] || 0) - 1 + totalImages) % totalImages
    }));
  };

  const handleNextImage = (eventId: number, totalImages: number) => {
    setCurrentImageIndex(prev => ({
      ...prev,
      [eventId]: ((prev[eventId] || 0) + 1) % totalImages
    }));
  };

  const featuredEvents = events.filter(event => event.featured);

  const upcomingEvents = [
    {
      id: 1,
      title: 'Feira Geração Verde Juventude e Acção Climática',
      date: '15 de Março, 2024',
      time: '14:00 - 18:00',
      location: 'Instituto Sapiens',
      spots: 50,
      category: 'Workshop',
      image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20and%20engaging%20green%20generation%20youth%20climate%20action%20fair%20event%20scene%20with%20young%20diverse%20participants%20actively%20discussing%20environmental%20sustainability%20solutions%20in%20a%20modern%20bright%20indoor%20venue%20with%20eco-friendly%20decorations%2C%20green%20plants%2C%20and%20educational%20displays%20about%20climate%20change%2C%20renewable%20energy%2C%20and%20conservation%20practices%2C%20featuring%20interactive%20booths%20and%20collaborative%20workshops%20in%20a%20professional%20yet%20welcoming%20atmosphere%20with%20natural%20lighting%20and%20contemporary%20design%20elements&width=800&height=600&seq=eventos-destaque-1&orientation=landscape',
      description: 'Participe de um evento transformador focado em juventude e sustentabilidade ambiental.',
    },
    {
      id: 2,
      title: 'Seminário: Liderança Empresarial Moderna',
      date: '22 de Março, 2024',
      time: '09:00 - 13:00',
      location: 'Hotel Presidente',
      spots: 80,
      category: 'Seminário',
      image: 'https://readdy.ai/api/search-image?query=A%20professional%20modern%20business%20leadership%20seminar%20with%20diverse%20executives%20and%20entrepreneurs%20engaged%20in%20an%20interactive%20presentation%20in%20an%20elegant%20hotel%20conference%20room%2C%20featuring%20a%20dynamic%20speaker%20on%20stage%2C%20contemporary%20audiovisual%20equipment%2C%20sophisticated%20lighting%2C%20and%20attendees%20taking%20notes%20in%20a%20bright%20upscale%20setting%20with%20clean%20minimalist%20design%20and%20corporate%20atmosphere&width=800&height=600&seq=eventos-destaque-2&orientation=landscape',
      description: 'Desenvolva suas competências de liderança com especialistas reconhecidos.',
    },
    {
      id: 3,
      title: 'Networking: Empreendedores de Angola',
      date: '5 de Abril, 2024',
      time: '18:00 - 21:00',
      location: 'Espaço Luanda',
      spots: 100,
      category: 'Networking',
      image: 'https://readdy.ai/api/search-image?query=An%20elegant%20professional%20networking%20event%20for%20Angolan%20entrepreneurs%20in%20a%20modern%20sophisticated%20venue%20with%20diverse%20business%20professionals%20mingling%20and%20exchanging%20ideas%2C%20featuring%20ambient%20lighting%2C%20contemporary%20furniture%2C%20refreshment%20stations%2C%20and%20a%20welcoming%20atmosphere%20conducive%20to%20business%20connections%2C%20with%20clean%20architectural%20lines%20and%20upscale%20decor%20in%20a%20bright%20spacious%20setting&width=800&height=600&seq=eventos-destaque-3&orientation=landscape',
      description: 'Conecte-se com outros empreendedores e expanda sua rede de contactos.',
    },
  ];

  const pastEvents = [
    {
      id: 1,
      title: 'Lançamento do Projecto Crescer',
      date: '13 Out 2025',
      location: 'Luanda, Angola',
      description:
        'Iniciativa de capacitação e desenvolvimento de competências para jovens empreendedores angolanos.',
      images: [
        'https://readdy.ai/api/search-image?query=Young%20African%20entrepreneurs%20attending%20a%20professional%20business%20training%20workshop%20in%20a%20modern%20conference%20room%20in%20Luanda%20Angola%20with%20simple%20clean%20white%20background%20bright%20natural%20lighting%20professional%20atmosphere%20participants%20taking%20notes%20and%20engaging%20with%20presenter%20realistic%20corporate%20photography%20style&width=800&height=600&seq=crescer1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Group%20of%20motivated%20young%20African%20professionals%20collaborating%20on%20business%20project%20in%20bright%20modern%20workspace%20in%20Angola%20with%20simple%20minimalist%20white%20background%20natural%20daylight%20professional%20setting%20teamwork%20and%20innovation%20realistic%20business%20photography&width=800&height=600&seq=crescer2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=African%20youth%20entrepreneur%20presenting%20business%20idea%20to%20audience%20at%20professional%20development%20event%20in%20Luanda%20with%20clean%20simple%20white%20background%20bright%20lighting%20confident%20speaker%20engaged%20audience%20realistic%20corporate%20event%20photography&width=800&height=600&seq=crescer3&orientation=landscape',
      ],
      link: 'https://www.projectocrescer.ao',
    },
  ];

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#CB9832]/5 via-white to-[#CB9832]/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <nav className="text-sm text-gray-600 mb-6">
            <a href="/" className="hover:text-[#CB9832] cursor-pointer">Início</a>
            <span className="mx-2">&gt;</span>
            <span className="text-[#CB9832]">Eventos</span>
          </nav>
          <h1 className="text-5xl md:text-6xl font-bold text-black mb-6">EVENTOS</h1>
          {/*<p className="text-xl md:text-sm text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Participe dos nossos eventos e conecte-se com líderes do mercado.
          </p>*/}
        </div>
      </section>

      {/* Events List with Filters */}
      <section className="py-16 bg-[#F8F8F8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Sidebar Filters */}
            <div className="lg:w-1/4">
              <div className="bg-white rounded-2xl p-6 shadow-lg sticky top-24">
                <h3 className="text-xl font-bold text-black mb-4">Filtrar por Categoria</h3>
                <div className="space-y-2">
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setSelectedCategory(category.id)}
                      className={`w-full text-left px-4 py-2.5 rounded-lg font-medium transition-all cursor-pointer ${
                        selectedCategory === category.id
                          ? 'bg-[#2D5F3F] text-white'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      {category.label}
                    </button>
                  ))}
                </div>
                <button
                  onClick={() => setSelectedCategory('todos')}
                  className="w-full mt-4 text-[#2D5F3F] font-semibold hover:underline cursor-pointer"
                >
                  Limpar Filtros
                </button>
              </div>
            </div>

            {/* Events List */}
            <div className="lg:w-3/4">
              <div className="space-y-6">
                {filteredEvents.map((event) => (
                  <div key={event.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all flex flex-col md:flex-row">
                    <div className="md:w-1/3 h-64 md:h-auto overflow-hidden relative">
                      <img 
                        src={event.images[currentImageIndex[event.id] || 0]} 
                        alt={event.title} 
                        className="w-full h-full object-cover object-center" 
                      />
                      {event.images.length > 1 && (
                        <>
                          <button
                            onClick={() => handlePrevImage(event.id, event.images.length)}
                            className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-black w-10 h-10 rounded-full flex items-center justify-center shadow-lg transition-all cursor-pointer"
                          >
                            <i className="ri-arrow-left-s-line text-xl"></i>
                          </button>
                          <button
                            onClick={() => handleNextImage(event.id, event.images.length)}
                            className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-black w-10 h-10 rounded-full flex items-center justify-center shadow-lg transition-all cursor-pointer"
                          >
                            <i className="ri-arrow-right-s-line text-xl"></i>
                          </button>
                          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                            {event.images.map((_, index) => (
                              <button
                                key={index}
                                onClick={() => setCurrentImageIndex(prev => ({ ...prev, [event.id]: index }))}
                                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                                  (currentImageIndex[event.id] || 0) === index
                                    ? 'bg-white w-6'
                                    : 'bg-white/50 hover:bg-white/75'
                                }`}
                              ></button>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                    <div className="md:w-2/3 p-6 flex flex-col">
                      <div>
                        <div className="flex items-center gap-4 mb-3 text-sm text-gray-600">
                          <span className="flex items-center">
                            <i className="ri-calendar-line mr-2 text-[#CB9832]"></i>
                            {event.date}
                          </span>
                        </div>
                        <h3 className="text-2xl font-bold text-black mb-2">{event.title}</h3>
                        <p className="text-gray-600 mb-4">{event.description}</p>
                      </div>
                      {event.status === 'upcoming' && (
                       <div className="mt-4">
                      <a
                      href={
                        event.id === 1 || event.id === 3 
                          ? "https://www.semanadasustentabilidade.ao/" 
                          : event.id === 2 
                            ? "https://www.projectocrescer.ao/" // Substitua este caminho pelo link real do projecto
                            : "#"
                      }
                      target={event.id === 1 || event.id === 3 || event.id === 2 ? "_blank" : "_self"}
                      rel={event.id === 1 || event.id === 3 || event.id === 2 ? "noopener noreferrer" : ""}
                      className="inline-block bg-[#2D5F3F] text-white px-5 py-2 rounded-lg font-semibold text-sm hover:bg-[#234A32] transition-all whitespace-nowrap cursor-pointer"
                    >
                      SAIBA MAIS
                    </a>
                  </div>
                      )}
                      {event.status === 'past' && (
                        <div className="mt-4">
                          <a
                            href="https://www.unicef.org/angola/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block bg-[#2D5F3F] text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-[#234A32] transition-all whitespace-nowrap cursor-pointer"
                          >
                            SAIBA MAIS
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-[#CB9832] to-[#B8862D]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <p className="text-xl mb-8 leading-relaxed">
            Entre em contacto e descubra como podemos impactar a sua iniciativa.
          </p>
          <a
            href="/contato"
            className="inline-block bg-white text-[#CB9832] px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Falar com a Nossa Equipa
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}